import React, { useEffect, useRef, useState } from 'react';
import Toast from 'react-simple-toasts';
import { messages } from '../welcome-dashboard/messages';
import { FEATURE_CUSTOM_REDUX_V2 } from '../constant';
import { getStore } from '../Utils';
import { addWhiteboardAssets, getWhiteboardAssets, getWhiteboardCategories } from '../welcome-dashboard/Request.d';
import { useDispatch, useSelector } from 'react-redux';
import { hideApiLoader, showApiLoader } from '../redux/tool-webjam/actions';
import toast from 'react-simple-toasts';
import { CURRENT_ROOM_NAME, Constant } from '../../webjam/constant';
import Dialog from '../../base/ui/components/web/Dialog';
import { setConfirmationModalProps } from '../redux/tool-webjam-v3/actions';
import { ct, dynamicMessageLocale } from '../constant-Utils';


const file_Types = {
	"audio": ".mp3,.wav",
	"pdf": ".pdf"
};

const Upload = (props) => {

	const { changePopupState } = props;
	const fileRef = useRef();
	const dispatch = useDispatch();
	const { whiteboardCategories } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2]);
	const [selectedFile, setSelectedFile] = useState('');
	const [fileName, setFileName] = useState('');
	const [mediaCategory, setMediaCategory] = useState('');
	const [mediaType, setMediaType] = useState('');
	const [mediaCategoryIndex, setMediaCategoryIndex] = useState(-1);

	useEffect(() => {
		dispatch(getWhiteboardCategories())
	}, [])

	useEffect(() => {
		console.log("selected File ", selectedFile)
	}, [selectedFile])

	const getMediaCategory = (e) => {
		let getIndex = whiteboardCategories.findIndex(x => x._id === e.target.value);
		setMediaCategoryIndex(getIndex);
		setMediaCategory(e.target.value);
		if (getIndex >= 0) {
			if (whiteboardCategories[getIndex].types.indexOf("mp3") != -1) {
				fileRef.current.setAttribute("accept", "audio/mpeg")
			} else if (whiteboardCategories[getIndex].types.indexOf("pdf") != -1) {
				fileRef.current.setAttribute("accept", "application/pdf")
			} else {
				fileRef.current.setAttribute("accept", "audio/mpeg,application/pdf")
			}
		} else {
			fileRef.current.setAttribute("accept", "audio/mpeg,application/pdf")
		}
	}

	const handleBrowseButton = () => {
		fileRef.current.click();
	}

	const handleFileInput = (e) => {
		const file = e.target.files[0];
		let spl = file.name.split(".");
		let get_type = spl[spl.length - 1];
		get_type = get_type.toLowerCase();

		if (file_Types.audio.indexOf(get_type) == -1 && file_Types.pdf.indexOf(get_type) == -1) {
			Toast(ct("messages.fileTypeError", "messages") + file_Types.audio + "," + file_Types.pdf, Constant.App.ToastTime.LongCloseTime);
			return false;
		}

		if (file.size < 0) {
			Toast(ct("messages.fileSizeMinError", "messages"), Constant.App.ToastTime.LongCloseTime);
			e.target.value = null;
		}
		else if (get_type == 'pdf' && file.size > 104857600) {
			Toast(ct("messages.pdfSizeMaxError", "messages"), Constant.App.ToastTime.LongCloseTime);
			e.target.value = null;
		}
		else if ((get_type == 'mp3') && file.size > 209715200) {
			Toast(ct("messages.mp3SizeMaxError", "messages"), Constant.App.ToastTime.LongCloseTime);
			e.target.value = null;
		} else {
			let fileNameChosen = file.name;
			if (fileNameChosen.length > 30) {
				fileNameChosen = fileNameChosen.substr(0, 27) + "." + get_type;
			}
			setMediaType(get_type);
			setSelectedFile(file);
			setFileName(fileNameChosen);
		}
	};

	const submit = () => {
		if (!mediaCategory) {
			Toast(ct("messages.mediaCategoryRequired", "messages"), Constant.App.ToastTime.LongCloseTime)
		} else if (!selectedFile) {
			Toast(ct("messages.mediaFileRequired", "messages"), Constant.App.ToastTime.LongCloseTime)
		} else {
			if (whiteboardCategories[mediaCategoryIndex].types.indexOf(mediaType) == -1) {
				Toast(ct("messages.correctMediaCategory", "messages"), Constant.App.ToastTime.LongCloseTime)
			} else {
				const formData = new FormData();
				const { authOrganization } = getStore(FEATURE_CUSTOM_REDUX_V2)
				let organizationResponse = authOrganization?._id;
				let room_name = CURRENT_ROOM_NAME;

				formData.append("file", selectedFile);
				formData.append("organization_id", organizationResponse);
				formData.append("category_id", mediaCategory);
				formData.append("room_name", room_name);

				dispatch(showApiLoader())

				addWhiteboardAssets(formData).then(async res => {
					dispatch(hideApiLoader())
					if (res.status == 1) {
						dispatch(getWhiteboardAssets("?organization_id=" + authOrganization._id + "&room_name=" + room_name + "&page_num=1"))
						// toast(messages.fileUploadSuccess)
						changePopupState('')
					} else {
						let msg = await dynamicMessageLocale(res.data.msg);
						toast(msg, Constant.App.ToastTime.LongCloseTime)
					}
				}).catch(e => {
					console.log("error ", e);
				})
			}
		}
	}

	const removeLocalFile = () => {
		dispatch(setConfirmationModalProps({
			isShow: true,
			title: ct("Translate.typography.confirmation"),
			content: ct("Translate.messages.deleteFile"),
			onSuccess: () => {
				setFileName('');
				setSelectedFile('');
				fileRef.current.value = "";
				dispatch(setConfirmationModalProps({ isShow: false }));
			},
			onCancel: () => {
				dispatch(setConfirmationModalProps({ isShow: false }));
			}
		}));
	}

	return (
		<Dialog
			disableAutoHideOnSubmit={true}
			disableBackdropClose={true}
			hideCloseButton={true}
			onCancel={() => changePopupState('')}
			onSubmit={() => submit()}
			cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
			ok={{ translationKey: ct("Translate.buttonTitle.submit") }}
			titleKey={ct("rta-trmc.tools.uploadMedia")}
			rtaClassName="upload-modal-wrapper"
			testId='upload-modal-id'
		>
			<div className="upload-modal" >
				<span
					className="close custom-close"
					onClick={() => changePopupState('')}
				>
				</span>

				<div className="clipbord-copy">
					<div style={{ color: '#343a40', marginBottom: 'inherit' }}>{ct("rta-trmc.uploadMediaDialog.mediaCategory")}</div>
					<select className="form-control" onChange={getMediaCategory} value={mediaCategory}>
						<option key="select" value=''>{ct("rta-trmc.uploadMediaDialog.selectMediaCategory")}</option>
						{
							whiteboardCategories.map((e, i) => <option key={i} iterate={i} value={e._id}>{e.category_name}</option>)
						}
					</select>
				</div>
				<div className="file-uploader">
					<input type="file" accept="audio/mpeg,application/pdf" style={{ display: "none" }} ref={fileRef} onChange={handleFileInput} />
					<div>
						<div className="file-name" style={{ float: "left" }}>
							<button style={{ marginRight: "10px" }} onClick={handleBrowseButton} className="btn theme-btn">{ct("rta-trmc.uploadMediaDialog.chooseFile")}</button>
						</div>
						<div>
							{fileName &&
								<>
									<div className="file-name" style={{ color: "#343a40" }}>{fileName + ' '}
										<span onClick={removeLocalFile} className='remove-box' style={{ cursor: "pointer" }}>
											<i className="fa fa-times"></i>
										</span>
									</div>
								</>
							}
						</div>
						<div className="file-instruction" style={{ color: "#343a40", clear: 'both' }}>({ct("rta-trmc.uploadMediaDialog.fileFormats")})
						</div>
					</div>
				</div>
			</div>
		</Dialog>
	)
}

export default Upload;